export default Object.freeze({
  Windows: 1,
  Android: 2,
});
